module.exports = __webpack_public_path__ + "img/Eagle-Pose-Pomodoro.1b89fedb.jpg";